'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _smoothScroll = require('smooth-scroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

var _values2 = require('lodash/values');

var _values3 = _interopRequireDefault(_values2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripMeerInformatieV1.$inject = ['$window', '$timeout', '$compile', 'ApiService', 'BreakpointsConstants'];


var _ = { values: _values3.default };

var _module = angular.module('cb.strips.cbStripMeerInformatie', []);

_module.directive('cbStripMeerInformatieV1', cbStripMeerInformatieV1);

exports.default = _module;

/*@ngInject*/

function cbStripMeerInformatieV1($window, $timeout, $compile, ApiService, BreakpointsConstants) {
    var parentContainerElements = {};

    return {
        restrict: 'A',
        scope: {},
        link: cbStripMeerInformatieV1Link
    };

    function cbStripMeerInformatieV1Link(scope, element, attr) {
        var version = 1.00;
        // both the title elements
        var stripTitleElement = element[0].querySelector('.heading-strip-title');
        var stripSubTitleElement = element[0].querySelector('.heading-strip-subtitle');
        var isAnExpandableGroup = void 0;
        var scroll = new _smoothScroll2.default();
        initialize();
        initCbFunctions();

        // reformat the content of the elements so they can become expandable
        function initialize() {
            // get the base element of the directive
            var baseElement = element[0];

            baseElement.classList.remove('is-expandable');
            baseElement.classList.add('u-mb-0'); //Margin bottom 0 when part of meer-informatie group

            // create parent container
            var parentElem = document.createElement('div');
            parentElem.classList.add('expandable__parent__container');
            parentElem.classList.add('container');

            baseElement.parentNode.insertBefore(parentElem, baseElement);

            // get the container element which will be hidden
            var expandableContentContainer = baseElement.querySelector('.container');
            expandableContentContainer.classList.add('expandable__container');

            // creates the title container element
            var expandableTitleContainer = document.createElement('div');
            expandableTitleContainer.setAttribute('ng-click', 'toggleExpandable($event)');
            expandableTitleContainer.classList.add('expandable-title__container');
            expandableTitleContainer.setAttribute('ng-class', '{\'expandable-title__container--expanded\': isExpanded}');

            // Adding title classes
            stripTitleElement.classList.add('expandable-title');
            stripSubTitleElement.classList.remove('strip__subtitle');
            stripSubTitleElement.classList.add('expandable__subtitle');

            // duplicates the subtitle and title
            var wrapperContainer = document.createElement('div');
            wrapperContainer.appendChild(stripTitleElement.cloneNode(true));
            wrapperContainer.appendChild(stripSubTitleElement.cloneNode(true));
            expandableTitleContainer.appendChild(wrapperContainer);

            var arrowSpanElem = document.createElement('span');
            arrowSpanElem.classList.add('icon');
            arrowSpanElem.classList.add('expandable__icon');
            arrowSpanElem.setAttribute('ng-class', '{\'icon--arrow-down\': !isExpanded, \'icon--arrow-up\': isExpanded}');

            wrapperContainer.insertBefore(arrowSpanElem, expandableTitleContainer.querySelector('.heading-strip-subtitle'));

            // remove the titles
            expandableContentContainer.removeChild(expandableContentContainer.querySelector('.heading-strip-title'));
            expandableContentContainer.removeChild(expandableContentContainer.querySelector('.heading-strip-subtitle'));

            // hide when not expanded
            expandableContentContainer.setAttribute('ng-show', 'isExpanded');

            // execute the $compile flag
            var compiledTitle = $compile(angular.element(expandableTitleContainer))(scope);
            var compiledContainer = $compile(angular.element(expandableContentContainer))(scope);

            // add the new elements
            parentElem.appendChild(compiledTitle[0]);

            // If the directive is contained in a group of other related directives with the attribute
            // 'cb-strip-meer-informatie-v1="[identifier]"' then we want to do three things.
            // 1. Expand the first item in the group (if we are on desktop).
            // 2. Add different css styling the last parent container in the group.
            // 3. Collapse all other items when the clicked item is expanded (see the below function: "toggleExpandable")
            isAnExpandableGroup = !!attr.cbStripMeerInformatieV1;
            if (isAnExpandableGroup) {

                // Store the parent elements so we can figure out which one is the last one in the array
                if (!parentContainerElements[attr.cbStripMeerInformatieV1]) {
                    parentContainerElements[attr.cbStripMeerInformatieV1] = [];
                }
                parentContainerElements[attr.cbStripMeerInformatieV1].push(parentElem);

                // Wait for all items to be rendered before quering the DOM.
                $timeout(function () {
                    var groupItems = getExpandableGroupElements();

                    // Sanity check
                    if (!groupItems) {
                        return;
                    }

                    // Open up the first element
                    var firstExpandableElement = groupItems[0];
                    if (firstExpandableElement && $window.innerWidth >= BreakpointsConstants.sm) {
                        var elementScope = angular.element(firstExpandableElement).isolateScope();
                        elementScope.isExpanded = true;
                    }

                    // Give the last expandable element's parent container a class so we can style it differently.
                    var parentElements = parentContainerElements[attr.cbStripMeerInformatieV1];
                    var lastExpandableElementParentContainer = parentElements[parentElements.length - 1];

                    if (lastExpandableElementParentContainer) {
                        lastExpandableElementParentContainer.classList.add('expandable__parent__container--last-child');
                    }

                    var lastExpandableStrip = groupItems[groupItems.length - 1];

                    lastExpandableStrip.classList.remove('u-mb-0'); //Last strip needs bottom margin
                });
            }
        }

        function initCbFunctions() {
            var cbFunctions = {

                //ID has to be on heading with class heading-strip-title
                open: function open(id) {
                    if (!angular.isUndefined(id)) {
                        //Simulate click on box title to open it
                        var element = $('#' + id);
                        var parent = element.closest('.expandable-title__container');
                        if (!parent.hasClass('expandable-title__container--expanded')) {
                            element.click();
                        }
                    }
                }
            };

            ApiService.attach({
                'meer-informatie': cbFunctions
            });
        }

        scope.toggleExpandable = function (e) {
            scope.isExpanded = !scope.isExpanded;
            var node = e.currentTarget;
            if (scope.isExpanded) {
                $window.requestAnimationFrame(function () {
                    scroll.animateScroll(node);
                });
            }
        };

        function getExpandableGroupElements() {
            return _.values(document.querySelectorAll('[cb-strip-meer-informatie-v1="' + attr.cbStripMeerInformatieV1 + '"]'));
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/meer-informatie-v1/meer-informatie.directive.js
// module id = 954
// module chunks = 1